module.exports = __webpack_public_path__ + "img/ejemplo-cedula-al-dorso.e5658614.jpg";